export enum TenantRegisterType {
    Commercial = 0,
    Society = 1
}
